<template>
  <div>
    <v-layout row>
      <v-flex md12>
        <v-alert
          text
          type="error"
          icon="mdi-fire"
          :value="ciemException.error != null"
        >
          {{ ciemException.error }}
        </v-alert>
        <v-alert
          text
          outlined
          color="deep-orange"
          icon="mdi-cloud-alert"
          :value="ciemException.warning != null"
        >
          {{ ciemException.warning }}
        </v-alert>
        <v-alert
          text
          dense
          color="teal"
          icon="mdi-clock-fast"
          border="left"
          :value="ciemException.success != null"
        >
          {{ ciemException.success }}
        </v-alert>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex md2 />
      <v-flex md8>
        <v-card>
          <v-responsive>
            <v-img :src="logoCiem" class="ma-auto" width="215" height="107" />
          </v-responsive>
          <v-card-text>
            <v-layout row mt-5 mb-5>
              <v-flex md12>
                <v-card class="specific mx-auto" color="primary" dark>
                  <v-card-title
                    class="pink white--text"
                    style="justify-content: center"
                  >
                    <p
                      :style="{
                        textAlign: 'center',
                        lineHeight: '2em',
                        marginBottom: '0px',
                      }"
                      v-html="$t('authConfirm.message', [tel])"
                    ></p>
                  </v-card-title>
                </v-card>
              </v-flex>
            </v-layout>
            <v-layout row mt-5>
              <v-flex md3 />
              <v-flex md6>
                <v-text-field
                  :error-messages="$errors($v.form.codeConfirmation)"
                  v-model="$v.form.codeConfirmation.$model"
                  :label="$t('authConfirm.codeConfirmation')"
                  autofocus
                  autocomplete="off"
                />
              </v-flex>
            </v-layout>
          </v-card-text>

          <v-card-actions>
            <v-layout row>
              <v-flex>
                <v-btn
                  :loading="loading"
                  block
                  color="primary"
                  @click="confirm"
                  >{{ $t('button.confirmation') }}</v-btn
                >
              </v-flex>
              <v-flex>
                <v-btn block @click="cancelAuth()">{{
                  $t('button.cancel')
                }}</v-btn>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import logoCiem from '@/assets/img/logo-ciem.png'
import { required } from 'vuelidate/lib/validators'
export default {
  props: {
    ciemException: {
      type: Object,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    tel: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      logoCiem,
      form: {
        codeConfirmation: '',
      },
    }
  },
  methods: {
    cancelAuth() {
      this.$emit('cancelAuth')
    },
    confirm() {
      this.$v.$touch()
      if (!this.$v.form.$invalid) {
        this.$emit('confirm', this.$v.form.$model)
      }
    },
  },
  validations: {
    form: {
      codeConfirmation: {
        required,
      },
    },
  },
}
</script>
